import * as React from 'react';
import {connect} from 'react-redux';
import {browserHistory} from 'react-router';
import {Diamonds} from './Diamonds';
import Radium, { StyleRoot } from 'radium';
import * as Tgcc from '../tgccGlobal';
import {LeadForm} from '../Components/LeadForm';



const ulStyle:React.CSSProperties = {
    listStyleType:'none',
    display:'inline-block',
    width:'160px', 
    color:'white',
    cursor:'pointer',
    paddingLeft:'0px',
    position:'relative',
}

const ulLeftStyle = Object.assign({},ulStyle,{position:'relative',top:'-20px'});

const bottomListStyle: React.CSSProperties = {
    fontFamily:'BarlowLight',
    display:'flex',
    marginTop:'30px',
    borderTop:'1px solid rgb(233, 230, 230)',
    height:'485px'
}

const footerStyles: React.CSSProperties = {
    backgroundColor:'white',
    textAlign:'center',
    lineHeight:'4.2em',
    width:'100%',
    height:'61px',
    fontFamily:'Lulo',
}

const rightPanel: React.CSSProperties = {
    width:'50%',
    display:'flex',
    flexDirection:'column',
    justifyContent:'center',
    alignItems:'center',
    backgroundColor:'#3A54B4'
}
const licenseDiv : React.CSSProperties = {
    display:'flex'
}
const licenseImg: React.CSSProperties = {
    width:'125px'
}
class Props extends Tgcc.BaseProps {
    marginTop?:string
}

class _CampusFooter extends React.Component <Props,any > {

    openFAQ = () => {browserHistory.push(Tgcc.Routes.CampusFAQ)};
    openContact = () =>{browserHistory.push(Tgcc.Routes.CampusContact)};
    openAbout = () =>{browserHistory.push(Tgcc.Routes.CampusAbout)};
    openShipping = () => {browserHistory.push(Tgcc.Routes.CampusShipping)};
    openHowItWorks = () =>{browserHistory.push(Tgcc.Routes.CampusHowItWorks)};
    openRealCampusProducts = () =>{browserHistory.push(Tgcc.Routes.RealCampusProductListView)};

    containerDiv: React.CSSProperties = {
        width:'100%',
    }
    componentWillMount(){
        this.containerDiv.marginTop = this.props.marginTop
        if(this.props.marginTop)
            this.containerDiv.marginTop = this.props.marginTop;
    }

    getBottomSection(){
        return (
            <div style={bottomListStyle} className="campFtr">
               <LeadForm state={this.props.state} />
               <div style={rightPanel} className='campRightFt'>
                <ul style={ulLeftStyle} className='campUl'>
                    <li><i><div onClick={this.openAbout}>About Us</div></i></li>
                    <li><i><div onClick={this.openContact}>Contact</div></i></li>
                </ul>
                <ul style={ulStyle}>
                    <li><div onClick={this.openHowItWorks}><i>How It Works</i></div></li>
                    <li><div onClick={this.openFAQ}><i>FAQS</i></div></li>
                    <li><div onClick={this.openShipping}><i>Shipping &#38; Returns</i></div></li>
                </ul> 
                <div style={licenseDiv}>
                    <img style={licenseImg} src={Tgcc.ResolveUrl('~/images/newAffinityLogo.png')} />
                    <img style={licenseImg} src={Tgcc.ResolveUrl('~/images/CLC.png')} />
                    <img style={licenseImg} src={Tgcc.ResolveUrl('~/images/fermata.png')} />
                </div>              
                </div>
            </div>
        )
    }
    getFooter() {
        const currentYear = new Date().getFullYear();
        return (
            <div style={footerStyles} className="gc20">
                {`${currentYear} BY THE GRAPHIC COW COMPANY`}
            </div>
        );
    }
    

    render() {
            return (
            <div style={this.containerDiv}>
                {this.getBottomSection()}
                {this.getFooter()}
            </div>
        ) 
    }
}


const mapStateToProps = (state: Tgcc.GlobalState, ownProps: Tgcc.BaseProps) => {
    return { state: state};
};
export var CampusFooter = connect(mapStateToProps)(Radium(_CampusFooter));

